import { callSsoApi } from 'utils/fetch';

export const verifyEmail = (token: string): Promise<{ message?: string }> => {
  return callSsoApi(`/email-confirmation/verify?token=${token}`, 'GET');
};
